module.exports = __webpack_public_path__ + "small-building.acfb27a01bef225c96b94908701f1334.png";